module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-HeavyItalic.02a6d77a.woff2";